<template>
  <div>
    <div class="lg:flex bg-white gap-4 pt-0 pb-10">
      <div class="lg:w-3/5">
        <div class="custplanoverview">
          <div class="px-4 py-2">
            <p class="text-black font-semibold fsize18px">
              {{ getAllPayments.result[0].membershipName }}
            </p>
            <div class="flex gap-1 py-1">
              <p class="text-primary">Valid till :</p>
              <!-- <p>31st Dec,2024</p> -->
              <p
                v-if="getAllPayments.result[0].userId.currentMembership != null"
              >
                {{
                  new Date(
                    getAllPayments.result[0].userId.membershipValidity
                  ).toLocaleDateString("en-Gb", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })
                }}
              </p>
              <p v-else>-</p>
            </div>
            <p>
              <!-- Designed exclusively for visitors seeking a glimpse into our
              offerings -->
              {{ getAllPayments.result[0].membershipId.description }}
            </p>
          </div>
        </div>
        <div class="pt-3">
          <h2 class="text-primary fsize18px font-semibold">
            Included in your Plan
          </h2>
          <div class="overflow-y-auto h-72">
            <div
              v-for="items in getAllPayments.result[0].membershipId.features"
              class=""
            >
              <p class="py-2 custtextbor">{{ items.title }}</p>
            </div>
          </div>
          <!-- <p class="py-2 custtextbor">Career Option</p>
          <p class="py-2 custtextbor">Career Option</p>
          <p class="py-2 custtextbor">Volunteer with Us</p>
          <p class="py-2 custtextbor">Donate</p>
          <p class="py-2 custtextbor">Care Directory</p>
          <p class="py-2 custtextbor">
            Content (Resources:Blogs/Podcast/handbooks)
          </p> -->
        </div>
      </div>
      <div class="lg:w-4/5">
        <div class="custplanoverview p-4 mb-2">
          <div class="flex gap-8 items-center">
            <div>
              <h2 class="text-black font-semibold fsize18px pb-2">
                Upgrade to higher Plan
              </h2>
              <ul style="list-style-type: disc" class="pl-4 pb-2">
                <li>
                  Designed exclusively for visitors seeking a glimpse into our
                  offerings
                </li>
                <li>
                  Designed exclusively for visitors seeking a glimpse into our
                  offerings
                </li>
              </ul>
            </div>

            <div class="w-1/4" @click="handleClick('subscribe1')">
              <base-button
                outline
                class="w-full text-white bg-primary py-2 rounded-md"
              >
                Upgrade
              </base-button>
            </div>
          </div>
        </div>
        <div class="custplanoverview p-4 mb-2">
          <div class="flex gap-8 items-center">
            <div>
              <h2 class="text-black font-semibold fsize18px pb-2">
                Cancel your Subscription
              </h2>
              <ul style="list-style-type: disc" class="pl-4 pb-2">
                <li>
                  <!-- Designed exclusively for visitors seeking a glimpse into our
                  offerings -->
                  You can cancel your plan anytime with refunds
                </li>
                <li>
                  <!-- Designed exclusively for visitors seeking a glimpse into our
                  offerings -->
                  Charges may apply
                </li>
              </ul>
            </div>

            <div class="w-1/4">
              <base-button
                @click="handleClick('cancelsubscription')"
                class="bg-primary text-white w-full py-2 rounded-md"
                :disabled="
                  getAllPayments.result[0].userId.currentMembership == null
                "
              >
                Cancel Plan
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  computed: {
    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
    ...mapState("payment", { getAllPayments: "getAllPayments" }),
  },
};
</script>

<style>
.custtextbor {
  border-bottom: 1px solid #ececec;
}
</style>
